import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default (state = initialState.loadingSkus, action) => {
  switch (action.type) {
    case types.BEGIN_LOAD_SKUS:
      return true;
    case types.FINISH_LOAD_SKUS:
      return false;

    default:
      return state;
  }
};
